<template>
    <div class="configuration-page">
        <p class="breadcrumb">
            <button @click="goBack">< Back</button>
        </p>
        <div class=" configuration-container">
              <div class="inputs-container">
                  <p class="main-title">Customize your email</p>
                  <p class="main-subtitle">Your recipient will <strong>receive an email</strong> prompting them to <strong>redeem their gift</strong>. Pick a header, write your message and schedule when you’d like us to notify them and we’ll handle the rest.</p>
                    <div  v-if="!multipleNotificationDate" class="date-container">
                        <p class="title">Select the date you’d like to email</p>
                        <div class="date-input">
                            <DatePicker
                                v-model="selectedDate"
                                color="teal"
                                trim-weeks
                                :min-date="new Date()"
                                :attributes='calendarAttrs'
                            />
                            <div class="date-details">
                                <div class="date-detail">
                                    <p class="circle teal"></p>
                                    <div class="date-copy">
                                        <p class="title">Recipients Notification Date:</p>
                                        <p class="subtitle">{{ currentDateString }}</p>
                                    </div>
                                </div>
                                <div class="date-detail">
                                    <p class="circle indigo"></p>
                                    <div class="date-copy">
                                        <p class="title">Estimated Delivery Window:</p>
                                        <p class="subtitle">{{ estimatedShippingDate }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="message-container">
                        <p class="title">Write your custom message</p>
                        <textarea placeholder="Start typing here..." v-model="message" cols="30" rows="3" id="message"></textarea>
                    </div>
                    <div class="add-gift">
                        <p class="title">Add a gif or image</p>
                        <div class="categories-container">
                            <button @click="selectOccasion(occasion)" v-for="occasion in allOccasions" :key="occasion" :class="occasion == selectedOccasion ? 'selected' : ''">{{ occasion }}</button>
                        </div>
                        <div class="gifs-container">
                            <div class="loading" :class="gif.src == selectedGif ? 'selected' :'' " @click="selectGif(gif.src)" v-for="gif in currentGifs" :key="gif.src + gif.occasion">
                                <img class="lazyload" width="150" height="150" loading="lazy" :src="gif.src"/>
                            </div>
                            <label :for="'gif'" class="upload-gif">
                                <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/upload.svg?v=1706904622"/>
                                <input :id="'gif'" type="file" accept="image/*" class="file-uploader" @change="fileChange" />
                                <p>Click to Upload</p>
                            </label>
                            <div class="no-gif" :class="selectedGif == null ? 'selected' :'' " @click="selectGif(null)">
                                <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/noimage.svg?v=1706904622"/>
                                <p>No Image</p>
                            </div>
                        </div>
                    </div>
                    <div class="add-logo">
                        <p class="title">Add your logo or custom graphic <span>(optional)</span></p>
                        <div class="directions-container">
                            <div>
                                <p class="directions-title desktop">Upload image here</p>
                                <input :id="'logo'" type="file" accept="image/*" class="file-uploader" @change="fileLogoChange" />
                                <label :for="'logo'">Choose File <img class="lazyload" src="https://cdn.shopify.com/s/files/1/1363/8433/files/upload_purple.svg?v=1710535518"/></label>
                            </div>
                        </div>
                    </div>
                    <p @click="() => {expanded = !expanded}" class="mobile preview">Preview Email <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/preview.png?v=1720557362" alt="letter" class="letter"/></p>
              </div>
              <div class="preview-container" :class="expanded ? 'expanded' : ''">
                <img @click="() => {expanded = !expanded}" class="remove mobile" loading="lazy" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" />
                    <p class="title desktop">Email Preview</p>
                    <div class="blue-container">
                        <div class="mail-preview">
                            <img v-if="this.logoSelected && this.logoUpload" class="hb-logo" :src="selectedLogo"/>
                            <div v-else class="logo-placeholder">
                                <img :src="selectedLogo"/>
                            </div>
                            <p class="mail-title">
                                Hey <span>[Recipient]</span>, <span>[From]</span> sent <br/> you a gift! 🎉
                            </p>
                            <div v-if="message == ''" class="message-placeholder" >
                                <span>Your message here</span>
                            </div>
                            <p v-else class="mail-message">{{ message }}</p>
                            <img v-if="selectedGif" class="mail-gif" :src="selectedGif">
                            <div class="gif-placeholder" v-else>
                                <span>Gif</span>
                            </div>
                        </div>
                    </div>
                    <div class="recipients-container">
                        <p class="recipient-title">Recipients</p>
                        <div class="shipped-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th v-if="multipleNotificationDate">Notification Date</th>
                                        <th >From</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="recipient in emailFileData" :key="recipient.email">
                                        <td>{{recipient.firstName}} {{ recipient.lastName }}</td>
                                        <td>{{recipient.email}}</td>
                                        <td v-if="multipleNotificationDate">{{recipient.notificationDate.toLocaleString("en-US").split("T")[0]}}</td>
                                        <td>{{recipient.from}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                    </div>
            </div>
        </div>
        <div class="sticky-container">
            <button @click="createGifts()" class="happybox-button green border" :class="isLoading ? 'isLoading' : ''">{{buttonText}}</button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import axios from "axios";
export default {
    components: {
        Calendar,
        DatePicker
    },
    data(){
        return{
            gifs:[
                //Celebration
                //first 3 are Graduation
                {src:"https://media.giphy.com/media/kGuY7LXCNbUyCFbiNm/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/H6oV7ZbFYSTlvoG0R5/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/LM9APuedFPR5YWSmhM/giphy.gif", occasion:"Celebration"}

                ,{src:"https://media.giphy.com/media/BPJmthQ3YRwD6QqcVD/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/HloNK1z39EkEQcreIo/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/s2qXK8wAvkHTO/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/G96zgIcQn1L2xpmdxi/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/artj92V8o75VPL7AeQ/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/35HTaxVJWzp2QOShct/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ2FwYmRqYWFhenRzZzNjdG54bGF2Nng4ZTh2amN6aGs5enF2cmU4dyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/htHMAjOrrDcUXW7Bn8/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/B8CHqQLm4dXMUNmz0z/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/gFi7V9CRBQVW0/giphy.gif", occasion:"Celebration"}
                ,{src:"https://media.giphy.com/media/l8XYZYdlOHSrS/giphy.gif", occasion: "Celebration"}

                //Happy Birthday
                ,{src:"https://media.giphy.com/media/g5R9dok94mrIvplmZd/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/jCz1AWFI4SnRzCmj9l/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/WXdDuZ2ADlqMjvi3Qh/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/l4KibWpBGWchSqCRy/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/kaMwwM91UCxstRfvA3/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/l4KhS0BOFBhU2SYIU/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/5YULt69vGGexq/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/oVzzsjnJaCpr2/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/xThuWkj1FAYH4wmGfC/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/l46CtujrJsJzKhQ88/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/10Uc8CJKdfnPvq/giphy.gif", occasion:"Happy Birthday"}
                ,{src:"https://media.giphy.com/media/KdC9XVrVYOVu6zZiMH/giphy.gif", occasion:"Happy Birthday"}

                //Thank you
                //First 4 are teachers day
                ,{src:"https://media.giphy.com/media/ZGvVLG9s2GOATZ8wZm/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/Ket2skWdBo8lvqa3QU/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/WjnE0wWEGhWS6eX6g2/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/aGDK7Pck40dZN7w1NG/giphy.gif", occasion: "Thank you"}
                
                ,{src:"https://media.giphy.com/media/3o6vXURvyF7bmW1HGg/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/lrUU99mair7hf75Eb0/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/fVtcfEXWQJQUbsF1sH/giphy-downsized-large.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/xUPGcxpCV81ebKh7Vu/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/r7GrCqj3H1ZxlDuwoL/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/StuemRSudGjTuu5QmY/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/13B3a2WWKcEo9O/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/Svjh8g9spSoO7YxYAm/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/uWlpPGquhGZNFzY90z/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/apbnzaN01uPJzkSiqs/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/a4RBMfVnil5flWdYZw/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/28XVGIraFzKKI/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/eF6lwLEmWvExRTnIbZ/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/1gQ6f5kJdBtGPSmdgS/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/5jReeP5PbjYQdGykgk/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/xULW8v7LtZrgcaGvC0/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/J5GcMY9sIFbZgvmBMY/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/kHOts8xerNiFI6KdCO/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/aTSSZiC1Y1SBq/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/JlpjgShzDsrMIyFu5U/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/07h85fP8YleCWGRSjV/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/lQ08MYhyuLu00Af4AA/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/IvTIFDvulINIA/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/3oz8xIsloV7zOmt81G/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/3ohs7NuHL3gjbe2uGI/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/MtIF4jJEolvf3OEOsh/giphy.gif", occasion: "Thank you"}
                ,{src:"https://media.giphy.com/media/wIVA0zh5pt0G5YtcAL/giphy.gif", occasion: "Thank you"}

                //Self Care
                ,{src:"https://media.giphy.com/media/19Ik3PuuqoFnhTTfEi/giphy.gif", occasion: "Self Care"}
                ,{src:"https://media.giphy.com/media/3o7btW9s53TyntUsP6/giphy.gif", occasion: "Self Care"}
                ,{src:"https://media.giphy.com/media/YWiy4wzz72cXiJoD4f/giphy.gif", occasion: "Self Care"}
                ,{src:"https://media.giphy.com/media/xUPGcyi4YxcZp8dWZq/giphy.gif", occasion: "Self Care"}
                ,{src:"https://media.giphy.com/media/01Sc5ESfglwPIW3OvN/giphy.gif", occasion: "Self Care"}
                ,{src:"https://media.giphy.com/media/XfVjpE4Rzb8tssf6Fd/giphy.gif", occasion: "Self Care"}
                ,{src:"https://media.giphy.com/media/moLThsnVIgqIjp3B91/giphy.gif", occasion: "Self Care"}
                ,{src:"https://media.giphy.com/media/PoVLOYYo5yMCLXwbkW/giphy.gif", occasion: "Self Care"}
                ,{src:"https://media.giphy.com/media/McaVuCIETWnJfznXg3/giphy.gif", occasion: "Self Care"}

                //Thinking of you
                ,{src:"https://media.giphy.com/media/KZByDyD2voWqRXeoAW/giphy.gif", occasion: "Thinking of you"}
                ,{src:"https://media.giphy.com/media/4yqm7egRkeAm492ORN/giphy.gif", occasion: "Thinking of you"}
                ,{src:"https://media.giphy.com/media/Th4UBUAZBbMaRoVL1v/giphy.gif", occasion: "Thinking of you"}
                ,{src:"https://media.giphy.com/media/lmogXxKKdTXUpZjaMp/giphy.gif", occasion: "Thinking of you"}
                ,{src:"https://media.giphy.com/media/53MiBPTODPe8pTa9MI/giphy.gif", occasion: "Thinking of you"}
                ,{src:"https://media.giphy.com/media/EHmgzOBBfzI5aHsDQ5/giphy.gif", occasion: "Thinking of you"}
                ,{src:"https://media.giphy.com/media/Yle9Yz9izeVRyiwavn/giphy.gif", occasion: "Thinking of you"}
                ,{src:"https://media.giphy.com/media/IvSXunJL8Mjo4/giphy.gif", occasion: "Thinking of you"}
                ,{src:"https://media.giphy.com/media/CIbxmbUdJ1JmiLtkuH/giphy.gif", occasion: "Thinking of you"}

                //Fathers's Day
                ,{src:"https://media.giphy.com/media/wMt0tq2GUez8Q/giphy.gif", occasion: "Father's Day"}
                ,{src:"https://media.giphy.com/media/luP5g7RrgIEwc8BPff/giphy.gif", occasion: "Father's Day"}
                ,{src:"https://media.giphy.com/media/3rSLSWqjw8hnbn6m9M/giphy.gif", occasion: "Father's Day"}
                ,{src:"https://media.giphy.com/media/QYe14N3hOG0AA555dO/giphy.gif", occasion: "Father's Day"}
                ,{src:"https://media.giphy.com/media/rT1YDMXAyuKAapcBiq/giphy.gif", occasion: "Father's Day"}
                ,{src:"https://media.giphy.com/media/TO4xRVIdj2I1IlwELT/giphy.gif", occasion: "Father's Day"}
                ,{src:"https://media.giphy.com/media/AnhkwZBrixzt9Si7PU/giphy.gif", occasion: "Father's Day"}
            ],
            message:"",
            currentGif: null,
            selectedDate: new Date(),
            isLoading: false,
            selectedOccasion: "Celebration",
            fileUpload: null,
            file: null,
            fileSelected: false,
            logoUpload: null,
            logo: null,
            logoSelected: false,
            expanded: false,
        }
    },
    computed:{
        ...mapGetters([
            'selectedCollection',
            'addressQty',
            'emailFile',
            'emailFileData',
            'multipleNotificationDate'
        ]),
        collectionPrice(){
            return parseInt(this.selectedCollection.variants[0].price)
        },
        selectedGif(){
            if(this.fileSelected && this.fileUpload){
                return this.fileUpload
            }
            return this.currentGif;
        },
        selectedLogo(){
            if(this.logoSelected && this.logoUpload){
                return this.logoUpload
            }
            return "https://cdn.shopify.com/s/files/1/1363/8433/files/LOGO_200x_e0b6d3c3-af5a-4399-863b-4b92bd4aa271.png?v=1697480801";
        },
        calendarAttrs(){
            let nextDate = this.addWorkDays(new Date(this.currentDate),2);
            let finishDate = new Date(nextDate).setDate(nextDate.getDate() + 7);
            return [
                {
                    key: 'shipping',
                    highlight: 'indigo',
                    dates: { start: nextDate, end: finishDate },
                },
            ];
        },
        currentDate(){
            if(this.selectedDate)
                return this.selectedDate

            return new Date();
        },
        currentDateString(){
            return this.currentDate.toLocaleString('default', {  day: "numeric",month: 'long' });
        },
        estimatedShippingDate(){
            let nextDate = this.addWorkDays(new Date(this.currentDate),2);
            let finishDate = new Date(nextDate).setDate(nextDate.getDate() + 7);
            finishDate = new Date(finishDate);

            return nextDate.toLocaleString('default', {  day: "numeric",month: 'long' }) + " - " + finishDate.toLocaleString('default', {  day: "numeric" ,month: 'long' });
        },
        buttonText(){
            return this.isLoading ? "loading..." : "Proceed to Checkout"
        },
        currentGifs(){
            if(this.selectedOccasion != "View All"){
                return this.gifs.filter(x => x.occasion == this.selectedOccasion);
            }

            return this.gifs;
        },
        allOccasions(){
            let occasions = [...new Set(this.gifs.map(x => x.occasion))];

            occasions.push("View All")
            return occasions
        }
    },
    methods:{
        goBack(){
            this.$emit('changepage', false );
        },
        selectGif(gif){
            this.fileSelected = false;
            this.currentGif = gif;
        },
        addWorkDays(date, days) {   
            while (days > 0) {
                date.setDate(date.getDate() + 1);
                if (date.getDay() != 0 && date.getDay() != 6) {
                days -= 1;
                }
            }          
            return date;
        },
        async createGifts(){
            this.isLoading = true;
            let item = {
                id: this.selectedCollection.variants[0].id,
                quantity: this.addressQty,
                properties: {
                    _giftEmails: this.emailFile
                    ,notificationDate:this.selectedDate
                    ,gif:this.selectedGif
                    ,message: this.message
                    ,_tier: true
                    ,_compression: true
                },
            }
            if(this.logo && this.logoSelected){
                item.properties.logo = null;
            }
            this.ajaxAdd(item);
        },
        ajaxAdd(currentItem){
            var form_data = new FormData();
            for ( var key in currentItem ) {
                if(key == "properties"){
                    for(var pKey in currentItem[key]) {
                        if(pKey == "gif"){
                            if(this.file && this.fileSelected){
                                form_data.append(`properties[${pKey}]`, this.file);
                                continue;
                            }
                        }
                        if(pKey == "logo"){
                            if(this.logo && this.logoSelected){
                                form_data.append(`properties[${pKey}]`, this.logo);
                                continue;
                            }
                        }
                        form_data.append(`properties[${pKey}]`, currentItem[key][pKey]);
                    }
                }
                else
                    form_data.append(key, currentItem[key]);
            }
            axios
          .post("/cart/add.js", form_data)
          .then((response) => {
            let hasCart = localStorage.getItem("cartDate");
            if(!hasCart){
                let newDate = new Date();
                let stringDate = newDate.getFullYear() + "-"+ (newDate.getMonth() + 1) + "-" + newDate.getDate();
                localStorage.setItem("cartDate",stringDate);
            }
            localStorage.setItem('openCartDrawerOnLoad',true);
            location.href = "/";
          })
          .catch((err) => {
            console.log(err);
          });
        },
        isMobile() {
            return window.innerWidth < 768;
        },
        selectOccasion(value){
            this.selectedOccasion = value;
        },
        fileChange(event){
            this.file = event.target.files ? event.target.files[0] : null;
            if (event.target.files && event.target.files[0]) {
                var reader = new FileReader();

                let that = this;
                reader.onload = function (e) {
                    that.fileUpload = e.target.result;
                    that.fileSelected = true;
                }

                reader.readAsDataURL(event.target.files[0]);
            }
            event.target.value = '';
        },
        fileLogoChange(event){
            this.logo = event.target.files ? event.target.files[0] : null;
            if (event.target.files && event.target.files[0]) {
                var reader = new FileReader();

                let that = this;
                reader.onload = function (e) {
                    that.logoUpload = e.target.result;
                    that.logoSelected = true;
                }

                reader.readAsDataURL(event.target.files[0]);
            }
            event.target.value = '';
        }
    }
}
</script>

<style scoped>
.configuration-page{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.gift-banner-container{
    display: flex;
    gap: 15px;
    width: 100%;
    justify-content: center;
    align-items: center;
}

.configuration-container{
    width: 100%;
    display: flex;
    padding: 0% 0% 5%;
    justify-content: space-between;
}

.inputs-container,.preview-container{
    width: 50%;
    padding: 5%;
    position: relative;
}

.inputs-container{
    background: linear-gradient(#E7E5FD 0, #FEFAF7 50%, #FFFDF9 100%);
}

.preview-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #FFFDFA;
}

.preview-container .title{
    font-size: 4vw;
    text-align: left;
    color: #0f0c38;
    line-height: .9;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin-bottom: 1.2rem;
    width: 100%;
}

.blue-container{
    border-color: #e8e1ea;
    border-width: 1px;
    border-style: solid;
    border-radius: 28px;
    filter: drop-shadow(0px 0px 3px rgba(0,0,0,0.08 ));
    background: #e7eeff;
    padding: 5%;
    width: 100%;
}

.blue-container .main-title{
    font-family: "karla";
    font-size: 1vw;
    line-height: 1.2;
    color: #5e5e7f;
    border-bottom: 1px solid #a8aac2;
    padding-bottom: 2%;
    width: 100%;
}

.mail-preview{
    border: 1px solid #eae1eb;
    border-radius: 5px;
    background: #ffffff;
    padding: 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.hb-logo{
    width: 15%;
}

.mail-title{
    color: #0f0c38;
    font-size: 2.5vw;
    text-align: center;
    line-height: 1.2;
    margin-bottom: 0.5rem;
    font-family: ff-more-web-pro-condensed, Karla, sans-serif;
    font-weight: 300;
}

.add-gift{
    padding-bottom: 5%;
}

.mail-title span{
    color: #aaaaaa;
}

.mail-preview .mail-gif{
    width: 100%;
}

.mail-message{
    color: #0f0c38;
    font-size: 1vw;
    margin-top: 1rem;
    white-space: break-spaces;
}

.mail-legend{
    color: #0f0c38;
    font-size: 0.8vw;
}

.inputs-container .main-title{
    font-size: 4vw;
    text-align: left;
    color: #0f0c38;
    line-height: 0.9;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin-bottom: 1.2rem;
}

.inputs-container .main-subtitle{
    font-family: "karla";
    font-size: 1.3vw;
    line-height: 1.4;
    text-align: left;
    color: #0f0c38;
}

.add-gift .title,.message-container .title,.date-container .title, .add-logo .title{
    font-size: 2vw;
    line-height: 1;
    text-align: left;
    color: #0f0c38;
    margin-bottom: 3%;
    padding-bottom: 3%;
    margin-top: 5%;
    font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
    font-weight: 300;
    border-bottom: 1px solid lightgray;
}

.add-logo .title span{
    font-family: 'Karla', sans-serif;
    font-weight: 700;
    font-size: 1.15vw;
    font-style: italic;
}

.add-logo .subtitle{
    font-size: 1vw;
    line-height: 1;
    text-align: left;
    color: #0f0c38;
    margin: unset;
}

.message-container{
    padding: 5% 0%;
}

textarea{
    width: 90%;
    min-height: 20vh;
}

textarea{
    background: #FFFFFF !important;
    border: 1px solid #E5E7EB !important;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08) !important;
    border-radius: 4px !important;
    color: #0F0C38;
    height: unset !important;
    font-size: 1.2vw;
    accent-color: black;
}

textarea:focus-visible{
    border: 1px solid #E5E7EB !important;;
    outline: none;
}

.categories-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 2%;
    flex-wrap: wrap;
}

.categories-container button{
    margin: 0% 1%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 0.9vw;
    line-height: 1.3;
    color: #0F0C38;
    margin-bottom: 1%;
}

.categories-container button.selected{
    font-weight: bold;
    border-bottom: 1px solid #0F0C38;
    padding-bottom: 1%;
}

.gifs-container{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 5px;
}

.gifs-container .loading{
    width: 23%;
    height: auto;
    cursor: pointer;
    position: relative;
}

.gifs-container .loading img{
    z-index: 2;
    height: 100%;
    width: 100%;
    position: relative;
    aspect-ratio: 1
}

@keyframes scaleout {
  0% {
    transform: scale(0); }

  100% {
    transform: scale(1);
    opacity: 0; } }

.loading:before {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0%;
  left: 0%;
  width: 100%;
  padding-bottom: 100%;
  animation: skeleton-loading 1s linear infinite alternate;
}

.gifs-container .no-gif,.gifs-container .upload-gif{
    width: 23%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 12vh;
    background-color: #F2F6FF;
    flex-direction: column;
    gap: 10px;
}

.gifs-container .no-gif p,.gifs-container .upload-gif p{
    font-family: karla;
    font-size: 0.8vw;
    line-height: 1;
    margin: unset;
    color: #AEB0B4;
    font-weight: bold;
}

.gifs-container .no-gif img,.gifs-container .upload-gif img{
    width: 12%;
}

.gifs-container .selected{
    border: 2px solid greenyellow;
}

.date-input{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 5%;
}

.date-details{
    width: 40%;
    display: flex;
    gap: 10px;
    flex-direction: column;
}

.date-detail{
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.date-copy .title{
    font-family: "karla";
    font-size: 1vw;
    line-height: 1.7;
    font-weight: bold;
    text-align: left;
    color: #0f0c38;
    margin: 0;
    border: unset;
    padding: unset;
}

.date-copy .subtitle{
    font-family: "karla";
    font-size: 1vw;
    line-height: 1.7;
    text-align: left;
    color: #0f0c38;
    margin: 0;
}

.circle{
    width: 2vw;
    height: 2vw;
    margin: 0;
    border-radius: 2vw;
}

.circle.teal{
    background-color: #319795;
}

.circle.indigo{
    background-color: #5a67d8;
}

.finish-container{
    width: 100%;
    padding: 0% 5% 3%;
    text-align: right;
}

.happybox-button.orange{
    margin-top: 2%;
}

.preview-container .recipient-title{
    font-size: 1.5vw;
    line-height: 1;
    color: #0f0c38;
    margin-bottom: 2%;
    font-weight: bold;
  }

  .recipients-container{
    width: 100%;
    border-radius: 16px;
    background-color: white;
    margin-top: 5%;
    padding: 5% 2%;
    box-shadow: 0 0 2px #0000004d;
  }

  .shipped-table{
        width: 100%;
        overflow-x: scroll;
    }
    .shipped-table th{
        font-size: 1vw;
        border: unset;
        color: #0f0c38;
        padding: unset;
        text-align: center;
    }
    .shipped-table tbody{
        background-color: #f6f7fb;
        font-size: 1vw;
    }

    .shipped-table td{
        padding: 5px;
        text-align: center;
    }

    .shipped-table tbody,.shipped-table tbody th,.shipped-table tbody td {
        border: 1px solid #b8b9bb;
        border-collapse: collapse;
    }

    .sticky-container{
      position: fixed;
      bottom: 0%;
      width: 100%;
      display: flex;
      justify-content: center;
      background-color: #fafafacc;
      left: 0;
    }

    .sticky-container .happybox-button.green{
        margin: 1% 0%;
        width: unset;
        padding: 1% 10%;
    }

    .separator{
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    width: 100%;
  }

  .line-separator{
    height: 0px;
    border-top: 1px solid black;
    width: 40%;
  }

    .separator .text{
        font-size: 26px!important;
        letter-spacing: 1px;
        font-weight: 700;
        color: #150131;
        margin-bottom: 2px;
        position: relative;
        display: block;
        background: white;
        width: fit-content;
        padding: 0% 5%;
    }

    .directions-container{
        width: 100%;
        padding: 2%;
        background-color: white;
        box-shadow: 0 0 2px #0000004d;
        border-radius: 8px;
    }

    .directions-container div{
        display: flex;
        align-items: center;
        gap: 10px;
    }
  
    .directions-container p{
      margin: unset;
      color: #0f0c38;
      font-weight: bold;
  }
  
    .directions-title{
      font-size: 1.15vw;
      line-height: 1.2;
    }
  
    .directions-subtitle{
      font-size: 1vw;
      line-height: 1.2;
      padding-bottom: 1%;
    }
  
    .directions-container label{
        color: #a01adb;
        text-decoration: underline;
        font-weight: 700;
        font-size: 1.15vw;
        display: flex;
        gap: 10px;
        align-items: center;
        background-color: white;
        padding: 1% 5%;
        border-radius: 20px;
        box-shadow: 0 0 2px #0000004d;
    }

    .directions-container label img{
        height: 1.15vw;
    }
  
    .directions-subtitle a{
      text-decoration: underline;
      color: #0f0c38;
    }
  
    .file-uploader{
      height: unset !important;
      border: unset !important;
      margin: unset;
      padding: 1% 0% !important;
      font-size: 1.2vw;
      color: #0f0c38;
      display: none;
    }

    .gif-placeholder,.message-placeholder{
        display: flex;
        background-color: #f2f2f2;
        min-width: 60%;
        min-height: 150px;
        align-items: center;
        justify-content: center;
    }

    .gif-placeholder span,.message-placeholder span{
        color: #aaaaaa;
    }

    .message-placeholder{
        min-width: 80%;
    }

    .logo-placeholder{
        display: flex;
        background-color: #f2f2f2;
        align-items: center;
        justify-content: center;
        width: 60%;
        aspect-ratio: 5/1;
    }

    .logo-placeholder img{
        width: 20%;
        opacity: 0.2;
    }

    .breadcrumb{
		color: #0f0c38;
        text-decoration: underline;
        position: absolute;
        top: 0%;
        left: 5%;
        z-index: 1;
	}

	.breadcrumb > * {
		color: #a01adb;
        font-weight: bold;
		text-decoration: underline;
	}

@media only screen and (min-device-width: 767px){
    .configuration-container{
        transform: translateX(0px);
        position: relative;
    }

    .preview-container{
        position: sticky;
        top: 10%;
        height: 80vh;
        max-height: 80vh;
        overflow-y: scroll;
    }

    .happybox-button.orange{
        width: 90%;
        margin-top: 7%;
    }
}

@media only screen and (max-device-width: 767px){

    .gifs-container .selected{
        border: 5px solid #a01adb;
    }
    .configuration-container{
        flex-direction: column;
        padding: unset;
    }

    .gift-banner-container{
        flex-direction: column;
    }

    .inputs-container,.preview-container{
        width: 100%;
    }

    .inputs-container .main-title{
        font-size: 10vw;
    }

    .inputs-container .main-subtitle{
        font-size: 3.5vw;
        margin-bottom: 2rem;
    }

    .gifs-container .no-gif,.gifs-container .upload-gif{
        width: 60%;
        flex-shrink: 0;
    }

    .gifs-container .no-gif p,.gifs-container .upload-gif p{
        font-size: 3vw;
    }

    .add-gift .title,.message-container .title,.date-container .title{
        font-size: 5vw;
        font-family: 'Karla', sans-serif;
        font-weight: bold;
        margin-bottom: 5%;
    }

    .categories-container button{
        font-size: 3vw;
        margin-bottom: 2%;
    }

    .gifs-container{
        overflow-x: scroll;
        flex-wrap: nowrap;
    }

    .gifs-container .loading{
        width: 66%;
        flex-shrink: 0;
    }

    .message-container{
        width: 100%;
    }

    textarea{
        font-size: 3.5vw;
        width: 100%;
    }

    .date-container .title{
        width: 100%;
    }

    .date-input{
        flex-direction: column;
        gap: 20px;
    }

    .date-details{
        width: 70%;
    }

    .circle{
        width: 5vw;
        height: 5vw;
        margin: 0;
        border-radius: 5vw;
    }

    .date-copy .title{
        font-size: 3.5vw;
        margin: 0;
        line-height: 1.2;
        padding: 0;
    }

    .date-copy .subtitle{
        font-size: 3vw;
    }

    .blue-container .main-title{
        font-size: 3vw;
    }

    .preview-container .title{
        font-size: 6vw;
    }

    .preview-container .subtitle{
        font-size: 4vw;
    }

    .mail-title{
        font-size: 6vw;
    }

    .mail-message{
        color: #0f0c38;
        font-size: 3.5vw;
        margin-top: 1rem;
    }

    .mail-legend{
        color: #0f0c38;
        font-size: 3vw;
        text-align: center;
    }

    .happybox-button.orange{
        width: 100%;
        margin-top: 10%;
    }

    .finish-container{
        padding: 5% 5% 15%;
    }

    .separator{
        width: 100%;
        height: 2px;
        background-color: #e8e8e8;
        margin: 10% 0%;
        display: flex;
    }

    .shipped-table th{
        font-size: 3vw;
    }
    .shipped-table tbody{
        font-size: 3vw;
    }

    .sticky-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 5px;
        position: fixed;
        z-index: 4;
        align-items: center;
        box-shadow: 0 0 4px #0000004d;
        padding: 2%;
        height: 8vh;
        background-color: white;
    }

    .sticky-container .happybox-button.green{
      width: 90%;
      padding: 2%;
      font-size: 4vw;
    }

    .add-logo{
        width: 100%;
    }

    .add-logo .title{
        font-size: 5vw;
        font-family: 'Karla', sans-serif;
        font-weight: bold;
    }

    .add-logo .subtitle{
        font-size: 3vw;
    }

    .directions-title{
        font-size: 3vw;
    }

    .directions-container label{
        font-size: 3vw;
    }

    .breadcrumb{
        top: 0.5%;
    }

    .inputs-container{
        padding: 10% 8% 40%;
    }

    .directions-container label img{
        height: 3vw;
    }

    .directions-container{
        padding: unset;
        background-color: unset;
        box-shadow: unset;
    }

    .directions-container div{
        justify-content: center;
    }

    .directions-container label{
        width: 100%;
        justify-content: center;
        padding: 3%;
    }

    .add-logo .title span{
        font-size: 3.5vw;
    }

    .preview-container{
        position: fixed;
        height: 0vh;
        bottom: 0;
        z-index: 3;
        transition: height 1s ease-in-out;
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 0 4px #0000004d;
    }

    .preview-container.expanded{
        height: 80vh;
        padding-bottom: 8vh;
        overflow-y: scroll;
        padding-top: 10%;
    }

    .cta-containers{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin-bottom: 5%;
        position: sticky;
        top: 0%;
        z-index: 1;
    }

    .preview-container .recipient-title{
        font-size: 3.5vw;
    }

    .preview{
        width: 100%;
        display: flex;
        color: #a01adb;
        text-decoration: underline;
        font-size: 5vw;
        margin-top: 5%;
        justify-content: center;
        align-items: center;
        gap: 10px;
        background-color: #f3e9f4;
        font-weight: bold;
        width: 100vw;
        margin-left: -8vw;

    }

    .preview img{
        width: 10%;
    }
    
    .remove{
        position: absolute;
        top: 10%;
        z-index: 1;
        right: 12%;
        width: 5%;
    }
}
</style>